import { render } from "./ChangePasswordView.vue?vue&type=template&id=7e34a885&ts=true"
import script from "./ChangePasswordView.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__